import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const OnboardingFlagKey = {
  MERCHANT_CONTEXTUAL_ONBOARDING: featureFlagKey(
    "merchant-contextual-onboarding",
  ), // Enable Contextual self-serve onboarding (default: show Calendly)
  /** Merchant-app unified onboarding shell (MAR-502). */
  MERCHANT_UNIFIED_ONBOARDING: featureFlagKey("unified-onboarding"),
  /** Adds the RCS agent registration pages to Recover onboarding. Default OFF. */
  MERCHANT_RCS_ONBOARDING: featureFlagKey("rcs-onboarding"),
  MERCHANT_ONBOARDING_AI_CHATS: featureFlagKey("merchant-onboarding-ai-chats"), // Enable AI chat sidebar in merchant onboarding flows
  CONTEXTUAL_ONBOARDING: featureFlagKey("contextual-onboarding"), // Enable Contextual onboarding in marketing navigation
} as const;
